import { AirportCodes, AirportsColorTheme } from '../types/airports';

export enum Color {
	OnPrimarySurface = '#FCFCFC',
	Neutral92 = '#EBEBEB',

	// TO DO: Remove CVG colours above

	Secondary = '#305269',
	Tertiary1 = '#CFB023',
	Tertiary1Dark = '#2C2507',
	Tertiary1Light = '#F9F4DC',
	Tertiary2 = '#E9B458',
	Tertiary2Dark = '#2D1F06',
	Tertiary2Light = '#FAEFDB',
	Tertiary3 = '#EDC278',
	Tertiary3Dark = '#20131E',
	Tertiary3Light = '#F0E5EE',
	Tertiary4 = '#6F3D76',
	Tertiary4Dark = '#201122',
	Tertiary4Light = '#F0E4F1',
	Tertiary5 = '#EA7189',
	Tertiary5Dark = '#2C070E',
	Tertiary5Light = '#F9DCE1',
	Error = '#AB2127',
	ErrorDark = '#400C0F',
	ErrorLight = '#F8DDDE',
	Success = '#73C520',
	SuccessDark = '#27410B',
	SuccessLight = '#EBF9DC',
	Neutral1 = '#FFFFFF',
	Neutral2 = '#F7F9FA',
	Neutral3 = '#DBE3EC',
	Neutral4 = '#75787B',
	Neutral5 = '#76818C',
	Neutral6 = '#4B5259',
	Neutral94 = '#F0F0F0',
	OnBackground = '#171A1C',
	OnBackground2 = '#000E29',
	Border = '#ACB2B9',
	BorderCard = '#E4E5E7',
	InputBackground = '#F1F2F3',
	DisabledBackground = '#D5D9DC',
	DisabledColor = '#5D666F',
	DarkLabel = '#071722',
	PrimaryOrange = '#E75A2A',
	BorderFocus = '#6F98D7',
	OnBackgroundLight = '#DFE8F6',
	ActiveBackgroundLight = '#AFC6E9',
	CategoryBackground = '#ECECEA',
	CategoryText = '#66665D',
}

export const airportsColorTheme: AirportsColorTheme = {
	[AirportCodes.IAH]: {
		primary: '#71B6E2',
		onPrimary: '#171A1C',
		primaryLight: '#DDEEF8',
		secondary: '#305269',
		onSecondary: '#FFFFFF',
		secondaryLight: '#437091',
		secondaryLighter: '#5085AB',
	},
	[AirportCodes.HOU]: {
		primary: '#90CC85',
		onPrimary: '#171A1C',
		primaryLight: '#E5F3E2',
		secondary: '#3D5936',
		onSecondary: '#FFFFFF',
		secondaryLight: '#57804E',
		secondaryLighter: '#68995E',
	},
	[AirportCodes.EFD]: {
		primary: '#A1B0C0',
		onPrimary: '#171A1C',
		primaryLight: '#E7EAEF',
		secondary: '#586D83',
		onSecondary: '#FFFFFF',
		secondaryLight: '#607790',
		secondaryLighter: '#69819B',
	},
	[AirportCodes.Spaceport]: {
		primary: '#A1B0C0',
		onPrimary: '#171A1C',
		primaryLight: '#E7EAEF',
		secondary: '#586D83',
		onSecondary: '#FFFFFF',
		secondaryLight: '#607790',
		secondaryLighter: '#69819B',
	},
	[AirportCodes.Corporate]: {
		primary: '#66665D',
		onPrimary: '#FFFFFF',
		primaryLight: '#ECECEA',
		secondary: '#1A355E',
		onSecondary: '#FFFFFF',
		secondaryLight: '#1F3F70',
		secondaryLighter: '#234880',
	},
};
